import Api from 'api';

import {
  ADD_EXCHANGE,
  GET_EXCHANGE_BY_ID,
  GET_EXCHANGE_FORM_CONFIG,
  GET_EXCHANGE,
  MODIFY_EDITING_EXCHANGE,
  RESET_EXCHANGE_FORM,
  RESET_EXCHANGE_LIST,
  SET_EXCHANGE_FILTERS,
  SET_EXCHANGE_PAGINATION,
  UPDATE_EXCHANGE,
} from 'exchange/constants';

import { SET_LISTS } from 'containers/lists/constants';

export const setPagination = (payload) => ({
  type: SET_EXCHANGE_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_EXCHANGE_FILTERS,
  payload,
});

export const getExchange = (companyId, filters, limit, page, orderBy, order) => ({
  type: GET_EXCHANGE,
  meta: { needAuth: true },
  payload: Api.exchange.get(companyId, filters, limit, page, orderBy, order),
});

export const resetList = () => ({ type: RESET_EXCHANGE_LIST });

export const resetForm = () => ({ type: RESET_EXCHANGE_FORM });

export const getExchangeById = (exchangeId, companyId, subcompanyId) => ({
  type: GET_EXCHANGE_BY_ID,
  meta: { needAuth: true },
  payload: Api.exchange.getById(exchangeId, companyId, subcompanyId),
});

export const modifyExchange = (payload) => ({ type: MODIFY_EDITING_EXCHANGE, payload });

export const addExchange = (companyId, subcompanyId, exchange) => ({
  type: ADD_EXCHANGE,
  payload: Api.exchange.add(companyId, subcompanyId, exchange),
});

export const updateExchange = (exchangeId, companyId, subcompanyId, exchange) => ({
  type: UPDATE_EXCHANGE,
  meta: { id: exchangeId, needAuth: true },
  payload: Api.exchange.update(exchangeId, companyId, subcompanyId, exchange),
});

export const getFormConfig = (companyId) => (dispatch) =>
  dispatch({
    type: GET_EXCHANGE_FORM_CONFIG,
    meta: { needAuth: true },
    payload: Api.exchange.formConfig(companyId),
  }).then(({ value: { catalogs } }) => {
    dispatch({ type: SET_LISTS, payload: { catalogs } });
  });



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/actions/exchange_actions.js